import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import { ShortcutKbd } from "@/components/ui/shortcut-keys";
import { useHasHoverPointer } from "@/hooks/use-mobile";

/**
 * Discoverability affordance for the double-tap-⌥ session switcher: a muted
 * "double-tap and hold ⌥ to switch sessions" subline rendered directly under
 * the "My Sessions" section header ("and hold" because the second press stays
 * held while J/K move the highlight and releasing commits). The keycap keeps its static muted style
 * regardless of the key state (the switcher overlay itself is the feedback
 * for the gesture).
 */
export function SessionSwitcherHint() {
  const $ = _c(9);
  const [isMac, setIsMac] = useState(true);
  const hasHoverPointer = useHasHoverPointer();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsMac(/Mac|iPhone|iPad|iPod/.test(navigator.userAgent));
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (!hasHoverPointer) {
    return null;
  }
  const keyLabel = isMac ? "\u2325" : "Alt";
  const t2 = `Double-tap and hold ${isMac ? "Option" : "Alt"} to switch sessions`;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="type-body-xxs-regular text-neutral-400 dark:text-neutral-500">double-tap and hold</span>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== keyLabel) {
    t4 = <ShortcutKbd className="h-4 min-w-4 align-text-bottom">{keyLabel}</ShortcutKbd>;
    $[3] = keyLabel;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="type-body-xxs-regular text-neutral-400 dark:text-neutral-500">to switch sessions</span>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t2 || $[7] !== t4) {
    t6 = <div aria-label={t2} className="px-3 pb-1.5 leading-4">{t3}{" "}{t4}{" "}{t5}</div>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}